export default "__VITE_ASSET__0141b789__"